import AlertType from './AlertType';
import { IconComponentType } from '@creditflowresearch/uilib/Icon';
import IconInfo from '@creditflowresearch/uilib/Icon/IconInfo';
import IconCheckCircle from '@creditflowresearch/uilib/Icon/IconCheckCircle';
import IconCancelCircle from '@creditflowresearch/uilib/Icon/IconCancelCircle';
import IconWarning from '@creditflowresearch/uilib/Icon/IconWarning';

export const defaultIconMap: Record<string, IconComponentType> = {
  [AlertType.INFO]: IconInfo,
  [AlertType.SUCCESS]: IconCheckCircle,
  [AlertType.ERROR]: IconCancelCircle,
  [AlertType.WARNING]: IconWarning,
};
